//@flow
import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import withoutColorIcon from '../../../../assets/img/without-color.svg';

type Props = {
  paletteColorsOpt: string[],
  paletteColorSelected?: string,
  setPaletteColorSelected: (color: string) => void,
  onSelect?: (color: string) => void,
};

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(1, 0),
    background: '#FFFFFF',
    boxShadow:
      '0px -1px 12px rgba(182, 182, 182, 0.25), 0px 1px 4px rgba(0, 0, 0, 0.06), 0px 3px 12px rgba(176, 176, 176, 0.25)',
    borderRadius: '8px',
    padding: theme.spacing(1),
  },
  contentColors: {},
  rowColors: {
    display: 'flex',
  },
  circle: {
    width: '2rem',
    height: '2rem',
    borderRadius: '50%',
  },
  btn: {
    border: '2px solid transparent',
  },
  btnSelected: {
    border: '2px solid #7B39FF',
  },
}));

export default function ColorsPalette(props: Props) {
  const {
    onSelect,
    paletteColorsOpt,
    paletteColorSelected,
    setPaletteColorSelected,
  } = props;

  const classes = useStyles();
  const handleSelectColor = (color: string) => {
    setPaletteColorSelected(color);
    if (onSelect) {
      // console.log(paletteColorSelected);
      onSelect(color);
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.contentColors}>
        {paletteColorsOpt && paletteColorsOpt.length ? (
          <div className={classes.rowColors}>
            <CustomButton
              className={`${classes.btn} ${
                paletteColorSelected === '' ? classes.btnSelected : ''
              }`}
              onClick={() => handleSelectColor('')}
            >
              <img
                src={withoutColorIcon}
                alt="without color"
                style={{width: '2rem'}}
              />
            </CustomButton>
            {paletteColorsOpt.map(color => (
              <CustomButton
                key={`color-${color}`}
                className={`${classes.btn} ${
                  paletteColorSelected === color ? classes.btnSelected : ''
                }`}
                onClick={() => handleSelectColor(color)}
              >
                <div
                  className={classes.circle}
                  style={{backgroundColor: color ? color : undefined}}
                />
              </CustomButton>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}

ColorsPalette.propTypes = {
  paletteColorsOpt: PropTypes.array.isRequired,
  paletteColorSelected: PropTypes.string,
  onSelect: PropTypes.func,
  setPaletteColorSelected: PropTypes.func.isRequired,
};
